<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    :color="$vuetify.theme.dark ? 'dark_backgroundBlack' : 'white'"
    flat
    height="50"
    class="pl-0"
  >
    <div class="app-bar-click-drawer" @click="clickDrawer">
      <v-icon
        v-if="!$vuetify.breakpoint.mobile"
        :color="$vuetify.theme.dark ? 'white' : 'secondary'"
        :size="21"
      >
        mdi-dock-left
      </v-icon>
      <v-icon v-else :color="$vuetify.theme.dark ? 'white' : 'secondary'">
        mdi-menu
      </v-icon>
    </div>

    <v-toolbar-title class="ml-3 app-bar-title">
      <span
        :class="{
          'secondary--text': !$vuetify.theme.dark,
          'white--text': $vuetify.theme.dark,
        }"
      >
        {{ $t(`appBar.title.${$route.name}`) }}
      </span>
    </v-toolbar-title>

    <v-spacer />

    <template v-if="user.status === 'TRIAL' || user.status === 'NO_PLAN'">
      <v-btn
        small
        color="accentYellow"
        class="app-bar-single-button elevation-0"
        @click="upgradeToPremium"
      >
        <template v-if="!isMobile">
          <v-icon size="13" class="mr-1" color="black">mdi-rocket-launch</v-icon>
          <span class="black--text">
            <template v-if="user.status === 'TRIAL'">
              {{ $t('appBar.goPlan.trialLeft1') }} {{ user.trialDays }}
              {{ $t('appBar.goPlan.trialLeft2') }}
            </template>
            <template v-else-if="user.status === 'NO_PLAN'">
              {{ $t('appBar.goPlan.goPlan') }}
            </template>
          </span>
        </template>
        <v-icon v-else size="17" class="mr-1" color="black">mdi-rocket</v-icon>
      </v-btn>
    </template>

    <template v-if="!isMobile">
      <v-btn
        small
        :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : 'darkBackgroundGrey'"
        class="app-bar-single-button elevation-0"
        href="https://www.filios.app/tutoriales/"
        target="_blank"
      >
        <v-icon size="12" class="mr-1" :color="$vuetify.theme.dark ? 'white' : 'black'">
          mdi-cursor-default-click
        </v-icon>
        <span :class="{ 'black--text': !$vuetify.theme.dark, 'white--text': $vuetify.theme.dark }">
          {{ $t('appBar.title.tutorial') }}
        </span>
      </v-btn>
    </template>

    <LanguageSelector :show-selector="!isMobile" :showFlagName="false" />

    <HideAmountsSelector />

    <ThemeSelector :show-selector="!isMobile" />

    <NotificationsBell />

    <v-menu offset-y content-class="elevation-1">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small v-bind="attrs" text class="px-0" v-on="on">
          <v-icon :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'">mdi-lifebuoy</v-icon>
        </v-btn>
      </template>

      <v-list nav>
        <v-list-item href="https://www.filios.app/tutoriales" target="_blank" class="py-0">
          <v-list-item-title>{{ $t('appBar.title.tutorial') }}</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://www.filios.app/guia-de-fiscalidad/" target="_blank" class="py-0">
          <v-list-item-title>{{ $t('appBar.title.taxGuide') }}</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://www.filios.app/contacta" target="_blank" class="py-0">
          <v-list-item-title>{{ $t('appBar.title.contact') }}</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://www.filios.app/contacta" target="_blank" class="py-0">
          <v-list-item-title>{{ $t('appBar.title.giveFeedback') }}</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://www.twitter.com/filios_app" target="_blank" class="py-0">
          <v-list-item-title>{{ $t('appBar.title.twitter') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <template v-if="user.role === 'admin'">
      <v-btn
        small
        text
        class="px-0"
        :disabled="!!supplantedUser"
        @click="$router.replace({ name: 'admin' })"
      >
        <v-icon :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'">
          mdi-shield-crown-outline
        </v-icon>
      </v-btn>
    </template>
  </v-app-bar>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import LanguageSelector from './LanguageSelector'
import HideAmountsSelector from './HideAmountsSelector'
import ThemeSelector from './ThemeSelector'
import NotificationsBell from '@/views/components/core/NotificationsBell'

export default {
  name: 'DashboardCoreAppBar',
  components: {
    LanguageSelector,
    NotificationsBell,
    HideAmountsSelector,
    ThemeSelector,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isDonateModalActive: false,
  }),
  computed: {
    ...mapState(['user', 'drawer', 'miniVariant', 'supplantedUser']),
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMiniVariant: 'SET_MINIVARIANT',
    }),
    ...mapActions({
      logout: 'LOGOUT',
    }),
    clickDrawer() {
      if (this.$vuetify.breakpoint.mobile) {
        this.setDrawer(!this.drawer)
        this.setMiniVariant(false)
      } else {
        this.setMiniVariant(!this.miniVariant)
      }
    },
    async donate() {
      this.isDonateModalActive = true
    },
    async upgradeToPremium() {
      return this.$router.replace({
        name: 'myAccount',
        query: { tab: 'billing' },
      })
    },
  },
}
</script>

<style lang="scss">
#app-bar {
  .app-bar-click-drawer {
    cursor: pointer;
    margin-bottom: 0px;
  }
  .app-bar-title {
    font-weight: 600;
    font-size: 15px;
  }
  .app-bar-single-button {
    margin-top: 2px;
    text-transform: none;
    font-size: 11px;
  }
}
</style>
